module.exports = __webpack_public_path__ + "static/media/q365.4ecb71fa.webp";